import React from 'react';
import './DemoLabel.scss';
import {
  ENVIRONMENT_LABELS,
  PRODUCTION_HOSTNAME,
} from '../../utils/helpers/constants.helper';

function DemoLabel() {
  const hostName = window.location.hostname;
  const environment = ENVIRONMENT_LABELS[hostName] || 'LOCAL';

  if (hostName === PRODUCTION_HOSTNAME) {
    return null;
  }

  return (
    <div className="demo" aria-hidden="true">
      FOR TESTING PURPOSE ONLY ({environment})
    </div>
  );
}

export default DemoLabel;
